'use strict';

function MemberFilter() {
    this._selectors = {
        filterItem: '.filter-item',
        filterItemToggle: '.filter-item-title',
        checkboxes: '.filter-item-entries input[type="checkbox"]',
        search: '.filter-search input[type="search"]',
        memberBoxesContainer: '.member-list',
        summary: '.filter-summary',
        chips: '.filter-chips',
        resultCount: '.filter-result-count',
        reset: '.filter-reset'
    }
    this._filters = {};
    this._searchDebounce = null;
    this._constructor();
}

MemberFilter.prototype._constructor = function () {
    this._populateFilterObject();
    this._UIActions();
    this._syncSummary();
    // Ausgangszustand in die History legen, damit der erste Zurueck-Schritt greift.
    this._pushUrlState(true);
}

/**
 * Baut den Filterzustand aus dem Markup auf. Der Server hat die Bedienelemente
 * bereits nach den URL-Parametern vorbelegt, daher ist das Markup die Quelle
 * der Wahrheit und der Zustand ueberlebt einen Reload oder einen geteilten Link.
 */
MemberFilter.prototype._populateFilterObject = function () {
    const _this = this;

    $(this._selectors.filterItem).each(function (index, element) {
        const filterItemId = $(element).data('id');
        _this._filters[filterItemId] = $(element)
            .find('input[type="checkbox"]:checked')
            .map(function () {
                return $(this).attr('value');
            })
            .get();
    });

    _this._filters.fullname = ($(this._selectors.search).val() || '').toString();
}

/**
 * Schreibt den aktuellen Filterzustand in die Adresszeile, damit eine gefilterte
 * Ansicht teilbar und ueber den Zurueck-Button erreichbar ist.
 */
MemberFilter.prototype._pushUrlState = function (replace) {
    if (typeof history.pushState !== 'function') {
        return;
    }

    const query = this.getFilterHttpQuery();
    const url = window.location.pathname + (query ? '?' + query : '');

    if (replace) {
        history.replaceState({ memberFilter: query }, '', url);
    } else {
        history.pushState({ memberFilter: query }, '', url);
    }
}

MemberFilter.prototype._UIActions = function () {
    const _this = this;
    $(_this._selectors.checkboxes).on('change', function () {
        _this._onCheckboxChange(this);
        _this.loadDataWithFilter();
    });

    $(_this._selectors.search).on('keyup change search', function () {
        const elem = this;
        clearTimeout(_this._searchDebounce);
        _this._searchDebounce = setTimeout(function () {
            // do the request only if min 3 letters
            const value = $(elem).val();
            if (value.length >= 3) {
                _this._filters.fullname = value;
                _this.loadDataWithFilter();
            } else {
                _this._filters.fullname = '';
                _this.loadDataWithFilter();
            }
        }, 275);
    });

    // Zurueck- und Vorwaerts-Button: Zustand aus der Adresszeile uebernehmen.
    $(window).on('popstate', function () {
        _this._applyStateFromUrl();
    });

    // Chip anklicken entfernt genau diesen Filter.
    $(document).on('click', '.filter-chip', function () {
        const parent = $(this).data('parent');

        if (parent === 'fullname') {
            $(_this._selectors.search).val('');
            _this._filters.fullname = '';
        } else {
            const value = String($(this).data('value'));
            $('input[data-parent="' + parent + '"][value="' + value + '"]').prop('checked', false);
            _this._filters[parent] = (_this._filters[parent] || []).filter(function (v) {
                return String(v) !== value;
            });
        }

        _this.loadDataWithFilter();
    });

    // Alles zuruecksetzen.
    $(document).on('click', _this._selectors.reset, function () {
        $(_this._selectors.checkboxes).prop('checked', false);
        $(_this._selectors.search).val('');
        Object.keys(_this._filters).forEach(function (key) {
            _this._filters[key] = Array.isArray(_this._filters[key]) ? [] : '';
        });
        _this.loadDataWithFilter();
    });

    $(document).on('click', function () {
        $(_this._selectors.filterItemToggle).parent().removeClass('active');
    });

    $(_this._selectors.filterItem).on('click', function (e) {
        e.stopPropagation();
    })

    $(_this._selectors.filterItemToggle).on('click', function (e) {
        const isCurrentlyActive = $(this).parent().hasClass('active');

        $(_this._selectors.filterItemToggle).parent().removeClass('active');

        if (!isCurrentlyActive) {
            $(this).parent().addClass('active');
            e.stopPropagation();
        }
    });


}

MemberFilter.prototype._onCheckboxChange = function (elem) {
    const _this = this;
    const $elem = $(elem);

    const checkboxValue = $elem.attr('value');
    const checkboxParentId = $elem.data('parent');

    // add value if checkbox is checked
    if ($elem.is(':checked')) {
        _this._filters[checkboxParentId].push(checkboxValue);
    } else {
        // remove value from filter Array
        const indexOfElement = _this._filters[checkboxParentId].indexOf(checkboxValue);
        _this._filters[checkboxParentId].splice(indexOfElement, 1);
    }
}

MemberFilter.prototype.loadDataWithFilter = function (skipHistory) {
    const _this = this;
    const data = _this.getFilterHttpQuery();

    if (!skipHistory) {
        _this._pushUrlState(false);
    }

    // Site-relativer Endpunkt aus dem Markup; Fallback auf die deutsche Route.
    const searchUrl = $('.filter').data('search-url') || '/member-search';

    $(_this._selectors.memberBoxesContainer).addClass('is-loading');

    $.ajax(searchUrl, {
        method: 'get',
        data,
        success: function (response) {
            $(_this._selectors.memberBoxesContainer)
                .removeClass('is-loading')
                .html(response);
            _this._syncSummary();
        },
        error: function () {
            $(_this._selectors.memberBoxesContainer).removeClass('is-loading');
        }
    });
}

/**
 * Uebernimmt den Zustand aus der Adresszeile in die Bedienelemente und laedt neu.
 * Wird beim Zurueck- und Vorwaerts-Button aufgerufen; schreibt selbst keine
 * History, sonst entstuende eine Endlosschleife.
 */
MemberFilter.prototype._applyStateFromUrl = function () {
    const _this = this;
    const params = new URLSearchParams(window.location.search);

    $(this._selectors.filterItem).each(function () {
        const id = $(this).data('id');
        const raw = params.get(id);
        const values = raw ? raw.split(',') : [];

        _this._filters[id] = values;
        $(this).find('input[type="checkbox"]').each(function () {
            $(this).prop('checked', values.indexOf($(this).attr('value')) !== -1);
        });
    });

    const term = params.get('fullname') || '';
    _this._filters.fullname = term;
    $(this._selectors.search).val(term);

    _this.loadDataWithFilter(true);
}

/**
 * Haelt Zaehler-Badges, Chips und Trefferzahl mit dem Filterzustand im Gleichklang.
 */
MemberFilter.prototype._syncSummary = function () {
    const _this = this;

    // Zaehler-Badge und Aktiv-Zustand je Dropdown
    $(this._selectors.filterItem).each(function () {
        const $item = $(this);
        const values = _this._filters[$item.data('id')] || [];
        const $title = $item.find(_this._selectors.filterItemToggle);

        $title.find('.filter-count').remove();
        $item.toggleClass('has-selection', values.length > 0);

        if (values.length > 0) {
            $title.find('.css-icon').before(
                $('<span class="filter-count"></span>').text(values.length)
            );
        }
    });

    // Chips fuer jede aktive Auswahl
    const $chips = $(this._selectors.chips).empty();
    let active = 0;

    Object.keys(this._filters).forEach(function (parent) {
        const values = _this._filters[parent];
        if (!Array.isArray(values)) {
            return;
        }
        values.forEach(function (value) {
            const $box = $('input[data-parent="' + parent + '"][value="' + value + '"]');
            const label = $box.closest('label').find('.text').text().trim() || value;
            active++;

            $('<button type="button" class="filter-chip"></button>')
                .attr('data-parent', parent)
                .attr('data-value', value)
                .text(label)
                .append('<i class="css-icon css-icon-x" aria-hidden="true"></i>')
                .appendTo($chips);
        });
    });

    // Freitextsuche ebenfalls als Chip
    const term = (this._filters.fullname || '').toString().trim();
    if (term !== '') {
        active++;
        $('<button type="button" class="filter-chip filter-chip--search"></button>')
            .attr('data-parent', 'fullname')
            .text(term)
            .append('<i class="css-icon css-icon-x" aria-hidden="true"></i>')
            .appendTo($chips);
    }

    $(this._selectors.reset).prop('hidden', active === 0);

    // Trefferzahl aus den tatsaechlich gerenderten Karten
    const count = $(this._selectors.memberBoxesContainer).find('.member-card').length;
    const template = $(this._selectors.summary).data('count-label') || '{count}';
    $(this._selectors.resultCount).text(template.replace('{count}', count));
}

/**
 * @returns {string}
 */
MemberFilter.prototype.getFilterHttpQuery = function () {
    const query = [];
    for (let property in this._filters) {
        if (this._filters[property].length > 0) {

            let value;
            // is value is array
            switch (typeof this._filters[property]) {
                case "object":
                    value = encodeURIComponent(this._filters[property].join(','))
                    break;
                case "string":
                    value = encodeURIComponent(this._filters[property])
                    break;
            }

            query.push(encodeURIComponent(property) + "=" + value);
        }
    }
    return query.join('&');
}

const memberFilter = new MemberFilter();